export const getUserDetails = state => state.session.checkoutDetails.user;

export const checkoutDetails = state => state.session.checkoutDetails;



// WEBPACK FOOTER //
// ./src/client/js/store/selectors/checkoutDetails.js